import Screen from '@/styles/Themes/Screen';
import styled, { css } from 'styled-components';
import Text from '@/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius, borders } from '@/styles/Themes/Metrics';
import { FlexPresets } from '@/styles/Themes/Presets';
import { Palette } from '@/styles/Themes/Palette';

export const CartContainer = styled.div`
    width: 100%;
    margin: 0;
    padding: 0 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    ${Screen.ipad} {
        padding: 0 60px 40px;
        margin: 0 auto 0;
    }
    ${Screen.desktop} {
        box-shadow: ${cssVars.shadow_card_default};
        border-radius: ${radius.small};
        background: ${cssVars.bg_white_dark3};
        max-width: 1064px;
        margin: 4px auto 40px;
        padding: 0 110px 40px;
    }
`;

export const Title = styled.h1`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.heading2}
    margin: 0 0 12px;

    ${Screen.desktop} {
        margin: 40px 0 20px;
    }
`;

export const SubTitle = styled.h2`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.heading3}
    margin: 20px 0;
`;

export const TopContainer = styled.div`
    padding: 0 25px;
    margin-bottom: 16px;

    ${Screen.ipad} {
        padding: 0 40px;
    }
    ${Screen.desktop} {
        padding: 0 78px;
    }
`;

export const PriceWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${cssVars.fg_gray_dark};
    ${Text.Mobile.heading4.bold};
    margin-bottom: 19px;

    ${Screen.ipad} {
        align-items: center;
        justify-content: center;
    }
`;

export const PriceDescription = styled.div`
    display: block;
    text-align: center;
    font-size: 10px;
    line-height: 1.4;
    margin-bottom: 12px;
    color: ${cssVars.fg_cart_description};
    ${Screen.ipad} {
        font-size: 12px;
        margin-bottom: 24px;
    }
`;

export const TotalPrice = styled.div`
    color: ${cssVars.fg_gray1_white};
    ${Text.Mobile.heading3};
    padding: 0 0 0 20px;

    ${Screen.ipad} {
        ${Text.Ipad.heading4};
    }

    ${Screen.desktop} {
        ${Text.Desktop.heading3};
    }
`;

export const Buttons = styled.div`
    ${Screen.ipad} {
        display: flex;
        justify-content: center;
        flex-direction: row-reverse;
    }
`;

export const ButtonWrapper = styled.div`
    margin: 10px 0;
    height: 40px;
    ${Text.Full.large.medium};
    > button {
        ${Text.Full.large.medium};
    }

    ${Screen.ipad} {
        display: flex;
        width: 250px;
        margin: 0 10px;
    }
`;

export const PromoWrapper = styled.div`
    text-align: center;
    background-color: ${cssVars.bg_ash_dark2};
    padding: 23px 24px;
    border-radius: ${radius.small};
    margin: 12px 0;

    ${Screen.ipad} {
        margin: 24px 0;
    }

    ${Screen.desktop} {
        margin: 28px auto;
        width: 680px;
        padding: 41px 55px;
    }
`;

export const PromoTitle = styled.div`
    display: flex;
    color: ${cssVars.fg_gray1_white};
    ${Text.Mobile.large.medium};
`;

export const PromoBottomWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    padding: 23px 0 16px;

    > button {
        width: 89px;
        height: 36px;
        ${Text.Full.normal.medium};
    }

    ${Screen.desktop} {
        > button {
            width: 150px;
            height: 45px;
            flex-grow: 0;
        }
    }
`;

export const PromoInput = styled.input`
    ${FlexPresets.flexRowCenter};
    border: ${borders.small} ${cssVars.fg_gray3_dark1};
    border-radius: ${radius.large};
    background-color: ${cssVars.bg_white_dark3};
    ${Text.Full.normal.medium};
    padding: 0px 20px;
    margin: 0px 10px 0 0;
    height: 36px;
    width: 61%;
    color: ${cssVars.svg_gray2_gray3};

    ${Screen.desktop} {
        width: 403px;
        height: 45px;
    }
`;

export const CartBottomWrapper = styled.div`
    width: 100%;
    max-width: 680px;
    ${Text.Full.large.medium};
    padding: 0 24px;

    ${Screen.ipad} {
        padding: 0 42px;
    }

    ${Screen.desktop} {
        padding: 0 56px;
        margin: 0 auto;
    }
`;

export const SubWrappers = styled.div`
    border-bottom: ${borders.small} ${cssVars.bg_gray4_dark1};
    padding-bottom: 15px;
`;

export const SubWrapperPromo = styled.div`
    display: flex;
    color: #0dd1c5;
    justify-content: space-between;
    ${Text.Mobile.large.medium};
    padding-bottom: 5px;
`;

export const SubWrapper = styled.div`
    display: flex;
    color: ${cssVars.fg_gray_dark};
    justify-content: space-between;
    ${Text.Mobile.large.medium};
    padding-bottom: 5px;
`;

export const ButtonWraper = styled.div`
    margin: 10px 0 0;

    ${Screen.desktop} {
        display: flex;
        justify-content: center;
        width: 250px;
        margin: 10px auto 0;
    }
`;

export const GrandTotal = styled.div`
    justify-content: space-between;
    display: flex;
    color: ${cssVars.fg_gray2_white};
    ${Text.Mobile.heading4};
    padding: 20px 0 0;
`;

export const TotalDescription = styled.div`
    margin: 0 auto;
    font-style: italic;
    color: ${cssVars.fg_gray3_dark1};
    ${Text.Full.medium.medium};
    width: fit-content;
    text-align: center;

    ${Screen.desktop} {
        margin: 0;
    }
`;

export const GrandTotalPrice = styled.div`
    color: ${cssVars.fg_black_white};
    ${Text.Full.large.medium};
`;

export const CartExpiredWrapper = styled.div`
    ${Screen.desktop} {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const CartFooter = styled.div`
    width: 100%;
    height: 72px;
    border-radius: 15px 15px 0px 0px;
    background-color: ${cssVars.bg_blue_dark3};
    position: Fixed;
    bottom: 0;
    box-shadow: ${cssVars.shadow_card_default};
    z-index: 2;

    ${Screen.ipad} {
        height: 65px;
    }
    ${Screen.desktop} {
        flex-wrap: nowrap;
    }
`;

export const CartWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    max-width: 1124px;
    width: 100%;
    height: 100%;
    margin: auto;

    ${Screen.ipad} {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px;
        flex-wrap: wrap;
    }
    ${Screen.desktop} {
        flex-wrap: nowrap;
    }
`;

export const FooterPrice = styled.div`
    ${FlexPresets.flexRowCenter};
    ${Text.Full.normal.medium};
    color: ${Palette.white.normal};
    padding: 2px 0;
    align-items: baseline;

    ${Screen.ipad} {
        ${Text.Ipad.medium.medium};
    }

    ${Screen.desktop} {
        ${Text.Desktop.medium.medium};
        height: 65px;
        justify-content: flex-start;
        align-items: center;
    }
`;

export const FooterButtons = styled.div`
    display: flex;
    padding: 0 0 4px;

    > button {
        width: 150px;
        height: 30px;
        margin: 0 10px;
        ${Text.Mobile.medium.medium};
    }

    ${Screen.ipad} {
        > button {
            width: 210px;
            margin: 0 10px;
            ${Text.Ipad.large.medium};
        }
    }

    ${Screen.desktop} {
        justify-content: flex-end;

        > button {
            ${Text.Desktop.large.medium};
            width: 200px;
            height: 35px;
        }
    }
`;

export const FooterTotalPrice = styled.div`
    ${Text.Full.large.semibold};
`;

export const SpinnerWrap = styled.div<{ isLoading: boolean }>`
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    z-index: 1;
    cursor: not-allowed;

    ${({ isLoading }) =>
        isLoading &&
        css`
            display: flex;
            justify-content: center;
            align-items: center;
            > * {
                &:first-child {
                    filter: drop-shadow(2px 4px 6px black);
                }
            }
        `}
`;

export const Loader = styled.img``;

export const TipText = styled.p`
    ${Text.Full.large.regular}
`;

export const Sur = styled.div`
    width: 210px;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
        text-decoration: underline;
    }

    ${Screen.desktop} {
        width: 300px;
    }
`;

export const RemovedWrapper = styled.div`
    margin-top: 100px;

    ${Screen.desktop} {
        margin: 0;
    }
`;

export const RemovedItems = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    ${Text.Full.large.medium};
    color: ${cssVars.fg_gray1_white};
    padding: 0 44px;
    margin: 28px 0;

    ${Screen.desktop} {
        padding: 0 77px;
        margin: 30px 0 40px;
    }
`;

export const RemovedItem = styled.a`
    color: ${Palette.state.info};
    ${Text.Full.large.medium};
    text-decoration: underline;
    cursor: pointer;
`;

export const Savings = styled.a`
    display: flex;
    justify-content: center;
    color: ${Palette.green.normal};
    ${Text.Full.large.regular};
    margin-bottom: 20px;
`;

export const PaypalCreditSection = styled.div`
    background: ${cssVars.bg_ash_normal};
    border-radius: ${radius.small};
    padding: 11px 8px;
    ${Text.Full.medium.regular};
    color: ${cssVars.fg_gray2_gray3};
    margin: 0 auto;

    ${Screen.ipad} {
        padding: 19px 20px 19px 25px;
        max-width: 380px;
        margin-top: 10px;
    }

    ${Screen.desktop} {
        max-width: 440px;
    }
`;
